/** Exports the auto-generated types and defines additional content that should not get overwritten when types are generated. */

import { Currency, CurrencyNames } from "./openexchangerates.org/currencies";
export { Currency, CurrencyNames };

export function isCurrency(code: string): code is Currency {
  return Object.values<string>(Currency).includes(code);
}

export const ALL_CURRENCIES = Object.values(Currency);
